export const summaryColDefs = [
    { header: 'Information', dataKey: 'GeneratedDateTime', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '50%', textAlign: 'left' } },
    { header: 'Amount', dataKey: 'NetPayable', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '50%', textAlign: 'right' } },
]
export const summaryData = [
   { info:'Receivable',amount:'5814'},
   { info:'Receivable',amount:'5814'},
   { info:'Receivable',amount:'5814'},
]

export const columnDefs = [
    { header: 'Date', dataKey: 'GeneratedDateTime', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '200px', textAlign: 'left' } },
    { header: 'LRNO', dataKey: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '13%', textAlign: 'left' } },
    { header: 'ChallanNo', dataKey: 'ChallanNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Vehicle No.', dataKey: 'BusNumber', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '130px', textAlign: 'left' } },
    
    { header: 'Vehicle Company', dataKey: 'BusCompanyName', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    
    { header: 'Paid Qty', dataKey: 'PaidItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'ToPay Qty', dataKey: 'TopayItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Total Qty', dataKey: 'totalItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
   
    { header: 'Paid Amount', dataKey: 'PaidAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    
    { header: 'ToPay Amount', dataKey: 'ActualTopayAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Total Amount', dataKey: 'TotalAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Charges', dataKey: 'Charges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'NetPayable', dataKey: 'NetPayable', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'From City', dataKey: 'FromCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
    { header: 'From Branch', dataKey: 'FromBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '200px', textAlign: 'left' } },
    { header: 'To City', dataKey: 'ToCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
    { header: 'To Branch', dataKey: 'ToBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '200px', textAlign: 'left' } },
    { header: 'Status', dataKey: 'receiveValue', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Receive', dataKey: 'receive', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'center' } },
    { header: 'Details', dataKey: 'details', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Is Luggage Received', dataKey: 'HasReceivedAtBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Remarks', dataKey: 'remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '200px', textAlign: 'left' } },
]
export const columnDefsExcel = [
    { header: 'Date', dataKey: 'GeneratedDateTime', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '200px', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'LRNO', dataKey: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '13%', textAlign: 'left' } , pdfColSx:{cellWidth: 81}},
    { header: 'ChallanNo', dataKey: 'ChallanNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Vehicle No.', dataKey: 'BusNumber', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    
    { header: 'Vehicle Company', dataKey: 'BusCompanyName', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    
    { header: 'Paid Qty', dataKey: 'PaidItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'ToPay Qty', dataKey: 'TopayItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Total Qty', dataKey: 'totalItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
   
    { header: 'Paid Amount', dataKey: 'PaidAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    
    { header: 'ToPay Amount', dataKey: 'ActualTopayAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Total Amount', dataKey: 'totalAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Charges', dataKey: 'Charges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'NetPayable', dataKey: 'NetPayable', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'From City', dataKey: 'FromCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'From Branch', dataKey: 'FromBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'To City', dataKey: 'ToCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'To Branch', dataKey: 'ToBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Status', dataKey: 'receiveValue', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Receive', dataKey: 'receive', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    // { header: 'Details', dataKey: 'details', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Is Luggage Received', dataKey: 'HasReceivedAtBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 81}  },
    { header: 'Remarks', dataKey: 'remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{width:81,cellWidth: 'wrap'}  },
]
export const detailedTblData = [
    {
        isSubHeading: true, dateTime: 'Receivable From Maharaja Travels', toPayData: [
            { isDataRow: true, date:'23-02-2025',challan:'612', vehicleNo:'MH40CM8061', vehicleCompany:'Saini Travels',paidQty:1, topayQty:0,totalQty:1,paidAmt:200,toPayAmt:0,totalAmt:200,charges:60,netPayable:140,fromCity:'Sangli', fromBranch:'Maharaja Travels',toCity:'Nagpur',toBranch:'Saini Travels',status:'Paid',receive:0,luggageRcvd:'Yes',remarks:'test' },
            { isDataRow: true, date:'23-02-2025',challan:'612', vehicleNo:'MH40CM8061', vehicleCompany:'Saini Travels',paidQty:1, topayQty:0,totalQty:1,paidAmt:200,toPayAmt:0,totalAmt:200,charges:60,netPayable:140,fromCity:'Sangli', fromBranch:'Maharaja Travels',toCity:'Nagpur',toBranch:'Saini Travels',status:'Paid',receive:0,luggageRcvd:'Yes',remarks:'test' },
            { isDataRow: true, date:'23-02-2025',challan:'612', vehicleNo:'MH40CM8061', vehicleCompany:'Saini Travels',paidQty:1, topayQty:0,totalQty:1,paidAmt:200,toPayAmt:0,totalAmt:200,charges:60,netPayable:140,fromCity:'Sangli', fromBranch:'Maharaja Travels',toCity:'Nagpur',toBranch:'Saini Travels',status:'Paid',receive:0,luggageRcvd:'Yes',remarks:'test' },
            { isTotalRow: true, dateTime: 'Total', paidQty: 1, topayQty: 0,paidAmt:200,toPayAmt:0,totalAmt:200,charges:60,netPayable:140},
        ]
    },
]

export const dispatchMemoColDefs = [
    { header: 'Manual LRNo', dataKey: 'LRNoManualLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Pickup City - Branch', dataKey: 'FromCityBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Sender Name', dataKey: 'Sender', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Receiver Name', dataKey: 'RecName', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Receiver Mobile No', dataKey: 'RecMobileNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'ItemType(Quantity)', dataKey: 'ItemAndQuantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Freight', dataKey: 'Freight', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Pay Type', dataKey: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Description', dataKey: 'Description', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
]

export const dispatchMemoColDefs2 = [
    { header: 'Payment Type', dataKey: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Total Quantity', dataKey: 'Quantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Total Amount', dataKey: 'NetAmount', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
]

export const headerColDefsExcel = [
    { header: 'From Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'To Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'From Company', dataKey: 'fromCompany', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'From Branch', dataKey: 'fromBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Franchisee', dataKey: 'franchisee', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Franchisee Branch', dataKey: 'franchiseeBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Status', dataKey: 'status', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
]
export const groupData = (data, loginData) => {
    const groupedData = {};
    const intCompanyID = loginData?.intCompanyID;

    // Group data by CompanyID and ChallanNo
    data.forEach(item => {
      const key = `${item.CompanyID}-${item.ChallanNo}`;

      if (!groupedData[key]) {
        let GroupByColumn = '';
        if (item.VehicleCompanyID === intCompanyID) {
          GroupByColumn = "Receivable From " + (item.CompanyID === intCompanyID ? item.DestinationCompanyName : item.CompanyName);
        } else {
          GroupByColumn = "Payable To " + (item.CompanyID === intCompanyID ? item.DestinationCompanyName : item.CompanyName);
        }
        groupedData[key] = {
          isSubHeading: true,
          GeneratedDateTime: GroupByColumn,
          toPayData: []
        };
      }

      groupedData[key].toPayData.push(item);
    });

    const combinedData = {};
    Object.values(groupedData).forEach(group => {
      const generatedDateTime = group.GeneratedDateTime;

      if (!combinedData[generatedDateTime]) {
        combinedData[generatedDateTime] = {
          isSubHeading: true,
          GeneratedDateTime: generatedDateTime,
          toPayData: []
        };
      }

      combinedData[generatedDateTime].toPayData = combinedData[generatedDateTime].toPayData.concat(group.toPayData);
    });
    return Object.values(combinedData).map(group => {
      const totalRow = {
        isTotalRow: true,
        GeneratedDateTime: 'Total',
        PaidItems: group.toPayData.reduce((sum, row) => sum + parseInt(row.PaidItems, 10), 0),
        TopayItems: group.toPayData.reduce((sum, row) => sum + parseInt(row.TopayItems, 10), 0),
        totalItems: group.toPayData.reduce((sum, row) => sum + parseInt(row.totalItems, 10), 0),
        PaidAmt: group.toPayData.reduce((sum, row) => sum + parseInt(row.PaidAmt, 10), 0),
        ActualTopayAmt: group.toPayData.reduce((sum, row) => sum + parseFloat(row.ActualTopayAmt), 0),
        ToPayComm: group.toPayData.reduce((sum, row) => sum + parseFloat(row.ToPayComm), 0),
        TopayAmt: group.toPayData.reduce((sum, row) => sum + parseFloat(row.TopayAmt), 0),
        totalAmt: group.toPayData.reduce((sum, row) => sum + parseFloat(row.totalAmt), 0),
        Charges: parseFloat(group.toPayData.reduce((sum, row) => sum + parseFloat(row.Charges), 0)).toFixed(2),
        NetPayable: parseFloat(group.toPayData.reduce((sum, row) => sum + parseFloat(row.NetPayable), 0)).toFixed(2)
      };

      group.toPayData.push(totalRow);
      return group;
    });
  };
 export const groupTables = (data, loginData) => {
    const groupedData = data.reduce((acc, row) => {
      const key = `${row.CompanyID}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(row);
      return acc;
    }, {});
    const mainData = Object.values(groupedData).map((list) => {
      const subGroup = list.reduce((acc, row) => {
        const key = `${row.ChallanNo}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(row);
        return acc;
      }, {});
      const listData = Object.values(subGroup).map((list) => {
        let obj = list.reduce((acc, curr) => {
          acc.PaidItems += parseInt(curr.PaidItems, 10) || 0;
          acc.TopayItems += parseInt(curr.TopayItems, 10) || 0;
          acc.totalItems += parseInt(curr.totalItems, 10) || 0;
          acc.PaidAmt += parseInt(curr.PaidAmt, 10) || 0;
          acc.ActualTopayAmt += parseFloat(curr.ActualTopayAmt) || 0;
          acc.TopayAmt += parseFloat(curr.TopayAmt) || 0;
          acc.ToPayComm += parseFloat(curr.ToPayComm) || 0;
          acc.totalAmt += parseFloat(curr.totalAmt) || 0;
          acc.Charges += parseFloat(curr.Charges) || 0;
          acc.NetPayable += parseFloat(curr.NetPayable) || 0;

          return acc;
        }, {
          ...list[0],
          PaidItems: 0, TopayItems: 0, totalItems: 0, PaidAmt: 0, ActualTopayAmt: 0, TopayAmt: 0, ToPayComm: 0, totalAmt: 0, Charges: 0, NetPayable: 0
        })
        return obj
      });
      return listData
    })
    const finalResult = groupData(mainData.flat(),loginData)
    return finalResult
  };

  export const  convertToInt32 = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) throw new Error("Invalid input");

    const rounded = Math.round(num);
    const diff = Math.abs(num - rounded);

    if (diff === 0.5) {
        // Bankers' rounding: round to nearest even
        return (rounded % 2 === 0) ? rounded : rounded - Math.sign(num);
    }

    return rounded;
}